import stations from "./stations.component";
import stationsUrls from "./stations.urls";
import StationsTransforms from "./stations.transforms";

const stationsModule = angular
  .module("app.components.stations", [])
  .component("stationsPage", stations)
  .service("StationsTransforms", StationsTransforms)
  .config(stationsUrls);

export default stationsModule;



// WEBPACK FOOTER //
// ./src/pages/stations/stations.module.js